
import { z } from "zod";

export const TaskStatusValues = ["BLOCKED", "COMPLETED", "IN_PROGRESS", "NEEDS_REVIEW", "TO_DO"] as const;
export const TaskStatusSchema = z.enum(TaskStatusValues);
export const TaskStatus = TaskStatusSchema.enum;
export type TaskStatus = (typeof TaskStatusValues)[number];
export const TaskStatusDisplayNames = { "BLOCKED": "Blocked",
"COMPLETED": "Completed",
"IN_PROGRESS": "In progress",
"NEEDS_REVIEW": "Needs review",
"TO_DO": "To do", } satisfies Record<TaskStatus, string>;
